import { Typography } from "@mui/material";
import { useStyles } from "./AppMenu.styles";
import { IAppMenuItem } from "./AppMenuItemInterfaces";

const AppMenuItem = ({ icon, onClick, text }: IAppMenuItem) => {
    const classes = useStyles();
    return (
        <div className={classes.appMenuItem} onClick={onClick}>
            {icon}
            <Typography className={classes.appMenuItemText}>{text}</Typography>
        </div>
    );
};

export default AppMenuItem;
